export const nationalityOptions = [
    { value: "4983ac00-73bc-ef11-b8e8-7c1e5202f8fb", label: "British" },
    { value: "2affb4c1-51bd-ef11-b8e9-00224843863c", label: "Afghan" },
    { value: "2cffb4c1-51bd-ef11-b8e9-00224843863c", label: "Albanian" },
    { value: "2effb4c1-51bd-ef11-b8e9-00224843863c", label: "Algerian" },
    { value: "8c00b5c1-51bd-ef11-b8e9-00224843863c", label: "American" },
    { value: "30ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Andorran" },
    { value: "32ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Angolan" },
    { value: "34ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Antiguan and Barbudan" },
    { value: "36ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Argentine" },
    { value: "38ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Armenian" },
    { value: "3affb4c1-51bd-ef11-b8e9-00224843863c", label: "Australian" },
    { value: "3cffb4c1-51bd-ef11-b8e9-00224843863c", label: "Austrian" },
    { value: "3effb4c1-51bd-ef11-b8e9-00224843863c", label: "Azerbaijani" },
    { value: "40ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Bahamian" },
    { value: "42ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Bahraini" },
    { value: "44ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Bangladeshi" },
    { value: "46ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Barbadian" },
    { value: "48ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Belarusian" },
    { value: "4affb4c1-51bd-ef11-b8e9-00224843863c", label: "Belgian" },
    { value: "4cffb4c1-51bd-ef11-b8e9-00224843863c", label: "Belizean" },
    { value: "4effb4c1-51bd-ef11-b8e9-00224843863c", label: "Beninese" },
    { value: "50ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Bhutanese" },
    { value: "52ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Bolivian" },
    { value: "54ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Bosnian" },
    { value: "58ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Brazilian" },
    { value: "5affb4c1-51bd-ef11-b8e9-00224843863c", label: "Bruneian" },
    { value: "5cffb4c1-51bd-ef11-b8e9-00224843863c", label: "Bulgarian" },
    { value: "5effb4c1-51bd-ef11-b8e9-00224843863c", label: "Burkinabe" },
    { value: "60ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Burundian" },
    { value: "64ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Cambodian" },
    { value: "66ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Cameroonian" },
    { value: "68ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Canadian" },
    { value: "62ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Cape Verdean" },
    { value: "6affb4c1-51bd-ef11-b8e9-00224843863c", label: "Central African" },
    { value: "6cffb4c1-51bd-ef11-b8e9-00224843863c", label: "Chadian" },
    { value: "6effb4c1-51bd-ef11-b8e9-00224843863c", label: "Chilean" },
    { value: "70ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Chinese" },
    { value: "72ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Colombian" },
    { value: "74ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Comorian" },
    { value: "80ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Congolese" },
    { value: "76ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Costa Rican" },
    { value: "78ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Croatian" },
    { value: "7affb4c1-51bd-ef11-b8e9-00224843863c", label: "Cuban" },
    { value: "7cffb4c1-51bd-ef11-b8e9-00224843863c", label: "Cypriot" },
    { value: "7effb4c1-51bd-ef11-b8e9-00224843863c", label: "Czech" },
    { value: "82ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Danish" },
    { value: "84ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Djiboutian" },
    { value: "86ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Dominican" },
    { value: "88ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Dominican" },
    { value: "1200b5c1-51bd-ef11-b8e9-00224843863c", label: "Dutch" },
    { value: "8affb4c1-51bd-ef11-b8e9-00224843863c", label: "Egyptian" },
    { value: "8a00b5c1-51bd-ef11-b8e9-00224843863c", label: "Emirati" },
    { value: "8effb4c1-51bd-ef11-b8e9-00224843863c", label: "Equatorial Guinean" },
    { value: "90ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Eritrean" },
    { value: "92ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Estonian" },
    { value: "94ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Eswatini" },
    { value: "96ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Ethiopian" },
    { value: "98ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Fijian" },
    { value: "2e00b5c1-51bd-ef11-b8e9-00224843863c", label: "Filipino" },
    { value: "9affb4c1-51bd-ef11-b8e9-00224843863c", label: "Finnish" },
    { value: "9cffb4c1-51bd-ef11-b8e9-00224843863c", label: "French" },
    { value: "9effb4c1-51bd-ef11-b8e9-00224843863c", label: "Gabonese" },
    { value: "a0ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Gambian" },
    { value: "a2ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Ghanaian" },
    { value: "a4ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Gibraltarian" },
    { value: "a6ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Greek" },
    { value: "a8ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Grenadian" },
    { value: "aaffb4c1-51bd-ef11-b8e9-00224843863c", label: "Guatemalan" },
    { value: "acffb4c1-51bd-ef11-b8e9-00224843863c", label: "Guinean" },
    { value: "aeffb4c1-51bd-ef11-b8e9-00224843863c", label: "Guinean-Bissauan" },
    { value: "b0ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Guyanese" },
    { value: "b2ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Haitian" },
    { value: "b4ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Honduran" },
    { value: "b6ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Hong Konger" },
    { value: "b8ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Hungarian" },
    { value: "baffb4c1-51bd-ef11-b8e9-00224843863c", label: "Icelander" },
    { value: "d4ffb4c1-51bd-ef11-b8e9-00224843863c", label: "I-Kiribati" },
    { value: "bcffb4c1-51bd-ef11-b8e9-00224843863c", label: "Indian" },
    { value: "beffb4c1-51bd-ef11-b8e9-00224843863c", label: "Indonesian" },
    { value: "c0ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Iranian" },
    { value: "c2ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Iraqi" },
    { value: "c4ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Israeli" },
    { value: "c6ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Italian" },
    { value: "c8ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Ivorian" },
    { value: "caffb4c1-51bd-ef11-b8e9-00224843863c", label: "Jamaican" },
    { value: "ccffb4c1-51bd-ef11-b8e9-00224843863c", label: "Japanese" },
    { value: "ceffb4c1-51bd-ef11-b8e9-00224843863c", label: "Jordanian" },
    { value: "d0ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Kazakh" },
    { value: "d2ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Kenyan" },
    { value: "3c00b5c1-51bd-ef11-b8e9-00224843863c", label: "Kittitian or Nevisian" },
    { value: "d6ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Kuwaiti" },
    { value: "d8ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Laotian" },
    { value: "daffb4c1-51bd-ef11-b8e9-00224843863c", label: "Latvian" },
    { value: "dcffb4c1-51bd-ef11-b8e9-00224843863c", label: "Lebanese" },
    { value: "e0ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Liberian" },
    { value: "e2ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Libyan" },
    { value: "e4ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Liechtensteinian" },
    { value: "e6ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Lithuanian" },
    { value: "e8ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Luxembourger" },
    { value: "eaffb4c1-51bd-ef11-b8e9-00224843863c", label: "Malagasy" },
    { value: "ecffb4c1-51bd-ef11-b8e9-00224843863c", label: "Malawian" },
    { value: "eeffb4c1-51bd-ef11-b8e9-00224843863c", label: "Malaysian" },
    { value: "f0ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Maldivian" },
    { value: "f2ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Malian" },
    { value: "f4ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Maltese" },
    { value: "f6ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Marshallese" },
    { value: "f8ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Mauritanian" },
    { value: "faffb4c1-51bd-ef11-b8e9-00224843863c", label: "Mauritian" },
    { value: "fcffb4c1-51bd-ef11-b8e9-00224843863c", label: "Mexican" },
    { value: "feffb4c1-51bd-ef11-b8e9-00224843863c", label: "Moldovan" },
    { value: "0000b5c1-51bd-ef11-b8e9-00224843863c", label: "Monegasque" },
    { value: "0200b5c1-51bd-ef11-b8e9-00224843863c", label: "Mongolian" },
    { value: "0400b5c1-51bd-ef11-b8e9-00224843863c", label: "Montenegrin" },
    { value: "0600b5c1-51bd-ef11-b8e9-00224843863c", label: "Moroccan" },
    { value: "deffb4c1-51bd-ef11-b8e9-00224843863c", label: "Mosotho" },
    { value: "56ffb4c1-51bd-ef11-b8e9-00224843863c", label: "Motswana (Botswana)" },
    { value: "0800b5c1-51bd-ef11-b8e9-00224843863c", label: "Mozambican" },
    { value: "0a00b5c1-51bd-ef11-b8e9-00224843863c", label: "Myanmar" },
    { value: "0c00b5c1-51bd-ef11-b8e9-00224843863c", label: "Namibian" },
    { value: "0e00b5c1-51bd-ef11-b8e9-00224843863c", label: "Nauruan" },
    { value: "1000b5c1-51bd-ef11-b8e9-00224843863c", label: "Nepali" },
    { value: "1400b5c1-51bd-ef11-b8e9-00224843863c", label: "New Zealander" },
    { value: "1600b5c1-51bd-ef11-b8e9-00224843863c", label: "Nicaraguan" },
    { value: "1a00b5c1-51bd-ef11-b8e9-00224843863c", label: "Nigerian" },
    { value: "1800b5c1-51bd-ef11-b8e9-00224843863c", label: "Nigerien" },
    { value: "9200b5c1-51bd-ef11-b8e9-00224843863c", label: "Ni-Vanuatu" },
    { value: "1c00b5c1-51bd-ef11-b8e9-00224843863c", label: "North Korean" },
    { value: "1e00b5c1-51bd-ef11-b8e9-00224843863c", label: "Norwegian" },
    { value: "2000b5c1-51bd-ef11-b8e9-00224843863c", label: "Omani" },
    { value: "2200b5c1-51bd-ef11-b8e9-00224843863c", label: "Pakistani" },
    { value: "2400b5c1-51bd-ef11-b8e9-00224843863c", label: "Palauan" },
    { value: "2600b5c1-51bd-ef11-b8e9-00224843863c", label: "Panamanian" },
    { value: "2800b5c1-51bd-ef11-b8e9-00224843863c", label: "Papuan" },
    { value: "2a00b5c1-51bd-ef11-b8e9-00224843863c", label: "Paraguayan" },
    { value: "2c00b5c1-51bd-ef11-b8e9-00224843863c", label: "Peruvian" },
    { value: "3000b5c1-51bd-ef11-b8e9-00224843863c", label: "Polish" },
    { value: "3200b5c1-51bd-ef11-b8e9-00224843863c", label: "Portuguese" },
    { value: "3400b5c1-51bd-ef11-b8e9-00224843863c", label: "Qatari" },
    { value: "3600b5c1-51bd-ef11-b8e9-00224843863c", label: "Romanian" },
    { value: "3800b5c1-51bd-ef11-b8e9-00224843863c", label: "Russian" },
    { value: "3a00b5c1-51bd-ef11-b8e9-00224843863c", label: "Rwandan" },
    { value: "9a00b5c1-51bd-ef11-b8e9-00224843863c", label: "Sahrawi" },
    { value: "3e00b5c1-51bd-ef11-b8e9-00224843863c", label: "Saint Lucian" },
    { value: "8cffb4c1-51bd-ef11-b8e9-00224843863c", label: "Salvadoran" },
    { value: "4400b5c1-51bd-ef11-b8e9-00224843863c", label: "Sammarinese" },
    { value: "4200b5c1-51bd-ef11-b8e9-00224843863c", label: "Samoan" },
    { value: "4600b5c1-51bd-ef11-b8e9-00224843863c", label: "São Toméan" },
    { value: "4800b5c1-51bd-ef11-b8e9-00224843863c", label: "Saudi" },
    { value: "4a00b5c1-51bd-ef11-b8e9-00224843863c", label: "Senegalese" },
    { value: "4c00b5c1-51bd-ef11-b8e9-00224843863c", label: "Serbian" },
    { value: "4e00b5c1-51bd-ef11-b8e9-00224843863c", label: "Seychellois" },
    { value: "5000b5c1-51bd-ef11-b8e9-00224843863c", label: "Sierra Leonean" },
    { value: "5200b5c1-51bd-ef11-b8e9-00224843863c", label: "Singaporean" },
    { value: "5400b5c1-51bd-ef11-b8e9-00224843863c", label: "Slovak" },
    { value: "5600b5c1-51bd-ef11-b8e9-00224843863c", label: "Slovenian" },
    { value: "5800b5c1-51bd-ef11-b8e9-00224843863c", label: "Solomon Islander" },
    { value: "5a00b5c1-51bd-ef11-b8e9-00224843863c", label: "Somali" },
    { value: "5c00b5c1-51bd-ef11-b8e9-00224843863c", label: "South African" },
    { value: "5e00b5c1-51bd-ef11-b8e9-00224843863c", label: "South Sudanese" },
    { value: "6000b5c1-51bd-ef11-b8e9-00224843863c", label: "Spanish" },
    { value: "6200b5c1-51bd-ef11-b8e9-00224843863c", label: "Sri Lankan" },
    { value: "6400b5c1-51bd-ef11-b8e9-00224843863c", label: "Sudanese" },
    { value: "6600b5c1-51bd-ef11-b8e9-00224843863c", label: "Surinamese" },
    { value: "6800b5c1-51bd-ef11-b8e9-00224843863c", label: "Swedish" },
    { value: "6a00b5c1-51bd-ef11-b8e9-00224843863c", label: "Swiss" },
    { value: "6c00b5c1-51bd-ef11-b8e9-00224843863c", label: "Syrian" },
    { value: "6e00b5c1-51bd-ef11-b8e9-00224843863c", label: "Taiwanese" },
    { value: "7000b5c1-51bd-ef11-b8e9-00224843863c", label: "Tajik" },
    { value: "7200b5c1-51bd-ef11-b8e9-00224843863c", label: "Tanzanian" },
    { value: "7400b5c1-51bd-ef11-b8e9-00224843863c", label: "Thai" },
    { value: "7600b5c1-51bd-ef11-b8e9-00224843863c", label: "Timorese" },
    { value: "7800b5c1-51bd-ef11-b8e9-00224843863c", label: "Togolese" },
    { value: "7a00b5c1-51bd-ef11-b8e9-00224843863c", label: "Tongan" },
    { value: "7c00b5c1-51bd-ef11-b8e9-00224843863c", label: "Trinidadian and Tobagonian" },
    { value: "7e00b5c1-51bd-ef11-b8e9-00224843863c", label: "Tunisian" },
    { value: "8000b5c1-51bd-ef11-b8e9-00224843863c", label: "Turkish" },
    { value: "8200b5c1-51bd-ef11-b8e9-00224843863c", label: "Turkmen" },
    { value: "8400b5c1-51bd-ef11-b8e9-00224843863c", label: "Tuvaluan" },
    { value: "8600b5c1-51bd-ef11-b8e9-00224843863c", label: "Ugandan" },
    { value: "8800b5c1-51bd-ef11-b8e9-00224843863c", label: "Ukrainian" },
    { value: "8e00b5c1-51bd-ef11-b8e9-00224843863c", label: "Uruguayan" },
    { value: "9000b5c1-51bd-ef11-b8e9-00224843863c", label: "Uzbek" },
    { value: "9400b5c1-51bd-ef11-b8e9-00224843863c", label: "Vatican" },
    { value: "9600b5c1-51bd-ef11-b8e9-00224843863c", label: "Venezuelan" },
    { value: "9800b5c1-51bd-ef11-b8e9-00224843863c", label: "Vietnamese" },
    { value: "4000b5c1-51bd-ef11-b8e9-00224843863c", label: "Vincentian" },
    { value: "9c00b5c1-51bd-ef11-b8e9-00224843863c", label: "Yemeni" },
    { value: "9e00b5c1-51bd-ef11-b8e9-00224843863c", label: "Zambian" },
    { value: "a000b5c1-51bd-ef11-b8e9-00224843863c", label: "Zimbabwean" },
];